// Generated by CoffeeScript 2.7.0
/* eslint-disable */

(function () {
  var ref,
    boundMethodCheck = function (instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new Error('Bound instance method accessed before binding');
      }
    };

  ref =
    window.Lanalytics.Plugins.StaticHtmlEventTracker = class StaticHtmlEventTracker extends (
      Lanalytics.Plugin
    ) {
      // This is the interface method expected by Lanalytics
      // Should return a valid instance of the plugin
      static newInstance(lanalytics) {
        return new Lanalytics.Plugins.StaticHtmlEventTracker(lanalytics);
      }

      constructor(lanalytics) {
        super(lanalytics);
        // It is important to use '=>' because then 'this' will be binded to StaticHtmlEventTracker instance (in order to access lanalytics)
        this.processStaticHtmlEvent = this.processStaticHtmlEvent.bind(this);
        this._init();
      }

      _init() {
        return $('*[data-lanalytics-event]').on(
          'click',
          this.processStaticHtmlEvent,
        );
      }

      processStaticHtmlEvent(event) {
        var clickedElement,
          eventData,
          eventResourceData,
          inContext,
          inContextElement,
          lanalyticsParentsOfElement,
          stmtVerb,
          verbElement;
        boundMethodCheck(this, ref);
        // Extract resource
        clickedElement = event.target;
        lanalyticsParentsOfElement = $(clickedElement).parents(
          '[data-lanalytics-resource]',
        );
        if (lanalyticsParentsOfElement.length === 0) {
          throw `No 'data-lanalytics-resource' field could be found in the parents of ${$(clickedElement).html().trim()}.`;
        }
        eventResourceData = lanalyticsParentsOfElement
          .first()
          .data('lanalytics-resource');
        verbElement = $(clickedElement).closest('[data-lanalytics-event]');
        if (verbElement.length === 0) {
          throw `No 'data-lanalytics-event' field could be found in the parents of ${$(clickedElement).html().trim()}.`;
        }
        eventData = verbElement.first().data('lanalytics-event');
        stmtVerb = new Lanalytics.Model.StmtVerb(eventData['verb']);
        // Extract inContext (optional)
        inContext = {};
        inContextElement = $(clickedElement).closest(
          '[data-lanalytics-context]',
        );
        if (inContextElement.length !== 0) {
          inContext = inContextElement.first().data('lanalytics-context');
        }
        return $(document).trigger('track-event', {
          verb: stmtVerb['type'],
          resource: eventResourceData['uuid'],
          resourceType: eventResourceData['type'],
          inContext: inContext,
        });
      }
    };
}).call(this);
